/**
 * Module definition houses global application services
 *
 * @module services.delivery
 */
angular.module('services.delivery', [
  'services.delivery.ReportsService',
  'services.delivery.SimulationService'
]);
